import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hdzdhxjbj6: FaireBrandEntity = {
  token: "b_hdzdhxjbj6",
  type: "brand",
  name: "Root To Vine",
  avatarUrl:
    "https://cdn.faire.com/fastly/e2907609e69ecb7dbee9db207e6b947b5956ab538e879ca12294da5df402ebfc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/86e5d14eda42df9c8f29b13e41bbd913d7c42d4d272a5bb8079db3b1f5929bd8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e2907609e69ecb7dbee9db207e6b947b5956ab538e879ca12294da5df402ebfc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/86e5d14eda42df9c8f29b13e41bbd913d7c42d4d272a5bb8079db3b1f5929bd8.jpeg",
  location: "Leo, IN, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 72,
  isTopShop: true,
  isInsider: true,
  description:
    "Root To Vine was born out of a desire to implement creativity into the makers daily life. The company had its beginnings in 2014 and it now sustains Sean and Amy fully. All of our decor is made from cast off literature creating eco-friendly decor pieces that evoke both a whimsical and nostalgic feeling for buyers. Each decor piece is handmade and features varying novels which means no two items are exactly the same. Our items are praised by book lovers along with people searching for that perfect unique gift for a loved one.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:29:02.442Z",
    importedBy: "entity-db-cli",
  },
};
